import { Box, type TextFieldProps } from "@mui/material";
import { type ReactNode } from "react";

export function readMaxLength(inputProps: TextFieldProps["inputProps"]): number | undefined {
  if (!inputProps || typeof inputProps !== "object" || !("maxLength" in inputProps)) {
    return undefined;
  }

  return typeof inputProps.maxLength === "number" ? inputProps.maxLength : undefined;
}

function hasHelperMessage(helperText: ReactNode) {
  if (helperText == null || helperText === false) {
    return false;
  }

  if (typeof helperText === "string") {
    return helperText.trim().length > 0;
  }

  return true;
}

/** Shows `length/max` only once the value has reached the field's character cap. */
export function characterLimitHelperText({
  helperText,
  maxLength,
  value,
}: {
  helperText?: ReactNode;
  maxLength?: number;
  value: unknown;
}): ReactNode {
  const length = typeof value === "string" ? value.length : 0;
  if (maxLength === undefined || length < maxLength) {
    return helperText;
  }

  const count = (
    <Box component="span" sx={{ color: "warning.main", fontWeight: 600, marginLeft: "auto" }}>
      {length}/{maxLength}
    </Box>
  );

  if (!hasHelperMessage(helperText)) {
    return (
      <Box component="span" sx={{ display: "flex", justifyContent: "flex-end", width: "100%" }}>
        {count}
      </Box>
    );
  }

  return (
    <Box component="span" sx={{ display: "flex", gap: 1, justifyContent: "space-between", width: "100%" }}>
      <Box component="span">{helperText}</Box>
      {count}
    </Box>
  );
}
